<script setup>
import { languages } from "@Utils/languages.js";
import { FormListbox } from "@Components/Form";
import { useI18n } from "vue-i18n";
import { computed, h } from "vue";
import _cloneDeep from "lodash/cloneDeep";

defineProps(["modelValue", "label"]);
defineEmits(["update:modelValue"]);

const { t: __ } = useI18n();

const formattedLanguages = computed(() => {
    let tranlatedLanguages = _cloneDeep(languages);
    return tranlatedLanguages.map((l) => {
        l.name = __(l.name);

        return l;
    });
});
</script>

<template>
    <FormListbox
        :label="label"
        :modelValue="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        required
        :items="formattedLanguages"
        item-key="key"
        item-display="name"
        item-icon="icon"
        :show-icon="true"
        searchable />
</template>
